import { Button } from "@tellescope/ui";
import { Select } from "@tellescope/design-system";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical, X } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface SortableProductRowProps {
  rowKey: string;
  productId: string;
  options: { id: string; title: string }[];
  disableRemove: boolean;
  onChange: (newId: string) => void;
  onRemove: () => void;
}

export const SortableProductRow = ({
  rowKey,
  productId,
  options,
  disableRemove,
  onChange,
  onRemove,
}: SortableProductRowProps) => {
  const { t } = useTranslation("calendar");
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: rowKey });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} className="rounded-md flex items-center p-2 border gap-2 bg-background">
      <button
        type="button"
        className="cursor-grab touch-none text-muted-foreground hover:text-foreground focus:outline-none"
        {...attributes}
        {...listeners}
      >
        <GripVertical size={16} />
      </button>
      <Select value={productId} onValueChange={onChange}>
        <Select.Trigger className="grow">
          <Select.Value placeholder={t("Select product...")} />
        </Select.Trigger>
        <Select.Content>
          {options.map((product) => (
            <Select.Item key={product.id} value={product.id}>
              {product.title}
            </Select.Item>
          ))}
        </Select.Content>
      </Select>
      <Button variant="ghost" onClick={onRemove} disabled={disableRemove}>
        <X />
      </Button>
    </div>
  );
};
